import { render, staticRenderFns } from "./sys.vue?vue&type=template&id=686827db&scoped=true&"
import script from "./sys.vue?vue&type=script&lang=js&"
export * from "./sys.vue?vue&type=script&lang=js&"
import style0 from "./sys.vue?vue&type=style&index=0&id=686827db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686827db",
  null
  
)

export default component.exports